
import { useRecoilState, useResetRecoilState } from "recoil"
import { alertState } from "./AlertDisplay.state"
import Alert from "../Alert"

const AlertDisplay = (props) => {
  const { className = "" } = props || {}
  const [{ id, type, message, closable, autoClose }] = useRecoilState(alertState)
  const clearAlert = useResetRecoilState(alertState)

  return (
    <Alert 
        id={id}
        className={className}
        color={type} 
        closable={closable} 
        autoClose={autoClose} 
        onClose={clearAlert}
    >
        {message}
    </Alert>
  )
}

export default AlertDisplay
